import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { BillingService } from '@modules/billing/services/billing.service';
import moment from 'moment';

@Component({
  selector: 'app-payments-step',
  templateUrl: './payments-step.component.html',
  styleUrls: ['./payments-step.component.scss']
})
export class PaymentsStepComponent implements OnInit {
  confirmationForm: FormGroup;
  billingData;

  showPreauthCard = true;
  showDownpaymentCard = false;
  showErrors = false;
  isPreauthComplete = false;
  isDownpaymentComplete = false;

  @Output() billStep = new EventEmitter<string>();
  @Output() confirmStep = new EventEmitter<string>();
  @Output() saveBillingData = new EventEmitter<{ [s: string]: any }>();
  displayedColumns: string[] = ['date', 'amount'];

  constructor(
    private snackbar: MatSnackBar,
    public billingService: BillingService
  ) {
    this.confirmationForm = new FormGroup({
      BillingCreditCardAuthorizationInd: new FormControl(false),
      BillingPaymentConfirmationInd: new FormControl(false),
    });
  }

  ngOnInit() {
    this.updateVisibilityAndStates();
    this.billingService.stepperState.subscribe(() => {
      this.updateVisibilityAndStates();
    })
  }

  get f() { return this.confirmationForm.controls; }

  billingStep(): void {
    this.billStep.emit(this.confirmationForm.value);
  }

  confirmationStep(): void {
    if (this.canStepForward()) {
      this.confirmStep.emit(this.confirmationForm.value);
    } else {
      this.showErrors = true;
      this.showSnackbar('Ensure all data is valid before continuing');
    }
  }

  showSnackbar(message: string) {
    this.snackbar.open(message, null, {
      duration: 2000,
    });
  }

  updateVisibilityAndStates() {
    const { billingData, PAYMENT_TYPES } = this.billingService
    this.showPreauthCard = true;
    this.showDownpaymentCard = false; // set to false since Bambora is no longer used for downpayments
    if (billingData.BillingPaymentTypeCd == PAYMENT_TYPES.invoice) {
      this.showPreauthCard = false;
    }
    const downpaymentAmt = parseInt(billingData.BillingDownpaymentAmt);
    if (downpaymentAmt == 0) {
      this.showDownpaymentCard = false;
    }

    if (billingData.BillingCreditCardAuthorizationInd) {
      this.f.BillingCreditCardAuthorizationInd.disable();
      this.f.BillingCreditCardAuthorizationInd.setValue(true);
    }
    if (billingData.BillingPaymentConfirmationInd) {
      this.f.BillingPaymentConfirmationInd.disable();
      this.f.BillingPaymentConfirmationInd.setValue(true);
    }
  }

  confirmBox(form) {
    this.f[form].setValue(true);
    this.f[form].disable();

    const body = {};
    body[form] = true;
    this.saveBillingData.emit(body);
  }

  canStepBack() {
    return !(this.f.BillingCreditCardAuthorizationInd.value && this.showPreauthCard) &&
      !(this.f.BillingPaymentConfirmationInd.value && this.showDownpaymentCard);
  }

  canStepForward() {
    return (!this.showPreauthCard || this.f.BillingCreditCardAuthorizationInd.value) &&
      (!this.showDownpaymentCard || this.f.BillingPaymentConfirmationInd.value);
  }

  formatDate(dateString: string): string {
    return moment.utc(dateString, 'YYYY-MM-DD').format('MMMM D, YYYY');
  }
}
